'use strict';

angular.module('programme')

.directive('navigation', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/navigation/navigation.html',
        controller: 'NavigationCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('NavigationCtrl', function ($scope, $element, currentArticleState)
{
    this.pages = currentArticleState.article.getPages();
    this.currentPage = currentArticleState.currentPage;
});
